import type { ApiProxyClient } from '../../types';

import { createExchangeToken } from './createExchangeToken';
import { consumeExchangeToken } from './consumeExchangeToken';

export const identityApi: ApiProxyClient['identity'] = {
    consumeExchangeToken,
    createExchangeToken,
};
